import { computed, ref } from 'vue';

import type { InjectionWithDefaults } from '../../../types/utils';
import { DEFAULT_PAGE_SIZE } from './DataView.constants';
import type { DataViewInjection } from './DataView.types';

// See: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject

/**
 * Miscellaneous data that is not related to pagination, sorting, or searching.
 * TODO: merge all DataView injections into one. https://leaflink.atlassian.net/browse/STASH-507
 */
export const DATA_VIEW_INJECTION: InjectionWithDefaults<DataViewInjection> = Object.freeze({
  key: Symbol('DATA_VIEW_INJECTION_KEY'),
  defaults: Object.freeze({
    // Pagination
    currentPage: computed(() => 1),
    isPaginateNextDisabled: computed(() => false),
    isPaginationEnabled: computed(() => false),
    pageCount: computed(() => 1),
    pageSize: computed(() => DEFAULT_PAGE_SIZE),
    totalDataCount: computed(() => 0),
    setPage() {},
    goPrevPage() {},
    goNextPage() {},

    // Sorting
    currentSortId: computed(() => undefined),
    currentSortOrder: computed(() => undefined),
    updateCurrentSort() {},

    // Search
    currentSearch: computed(() => ''),
    updateCurrentSearch() {},

    // Miscellanous
    density: computed(() => undefined),
    isEmpty: computed(() => false),
    isLoading: computed(() => false),
    isSelectable: ref(false),
    isWithinModule: computed(() => false),
    variant: computed(() => undefined),
  }),
});
